import { render, staticRenderFns } from "./_sidebarSettingsComponent.vue?vue&type=template&id=b50ac81e"
import script from "./_sidebarSettingsComponent.vue?vue&type=script&lang=js"
export * from "./_sidebarSettingsComponent.vue?vue&type=script&lang=js"
import style0 from "./_sidebarSettingsComponent.vue?vue&type=style&index=0&id=b50ac81e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports